import { z } from 'zod';
import { RemarkInput } from './supervision';

/** Создание сотрудником: один постоянный ключ на неизменное содержимое команды. */
export const RemarkCreateCommand = z.strictObject({
  clientOperationId: z.uuid(),
  expectedRevision: z.literal(0),
  payload: RemarkInput,
});
export type RemarkCreateCommand = z.infer<typeof RemarkCreateCommand>;

/** Квитанция не сохраняет Detail, свободный текст, суммы и ссылки на файлы. */
export const RemarkCreateResult = z.strictObject({ id: z.uuid(), number: z.string() });
export type RemarkCreateResult = z.infer<typeof RemarkCreateResult>;
export const RemarkCreateAck = z.strictObject({
  receiptId: z.uuid(),
  replayed: z.boolean(),
  result: RemarkCreateResult,
});
export type RemarkCreateAck = z.infer<typeof RemarkCreateAck>;

export const REMARK_PHOTO_MAX_BYTES = 10 * 1024 * 1024;
export const REMARK_PHOTO_EXTENSIONS = ['jpg', 'jpeg', 'png', 'webp', 'heic'] as const;
/** Only before is implemented. Other stages can be compared to an existing receipt before rejection. */
export const RemarkPhotoCommand = z.strictObject({
  schemaVersion: z.literal(1),
  clientOperationId: z.uuid(),
  expectedRevision: z.literal(0),
  projectId: z.uuid(),
  stage: z.enum(['before', 'after', 'doc']),
});
export type RemarkPhotoCommand = z.infer<typeof RemarkPhotoCommand>;
export const RemarkPhotoResult = z.strictObject({
  id: z.uuid(),
  remarkId: z.uuid(),
  stage: z.literal('before'),
});
export type RemarkPhotoResult = z.infer<typeof RemarkPhotoResult>;
export const RemarkPhotoAck = z.strictObject({
  receiptId: z.uuid(),
  replayed: z.boolean(),
  result: RemarkPhotoResult,
});
export type RemarkPhotoAck = z.infer<typeof RemarkPhotoAck>;
